<template>
  <div class="my-repairs none-height d-flex flex-column flex-grow-1">
    <div
      class="selector-container section-container d-flex"
      :class="{ dark: skinType }"
    >
       <SectionTitle title="我的抢修" ></SectionTitle>
      <el-form :inline="true" style="text-align: left" size="small">
        <el-form-item label="计划时间" :class="{ 'light-label': skinType }">
          <el-date-picker
            v-model="selectPeriod"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="exportTable">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table  size="small"
      :data="tableData"
      class="none-height flex-grow-1"
      style="width: 100%"
      height="0"
      stripe
            ref="table"
      :class="{ dark: skinType }"
      :row-class-name="
        (...nu) => {
          return skinType ? 'dark text-white' : '';
        }
      "
      @row-click="rowClickListener"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column prop="Title" label="标题"> </el-table-column>
      <el-table-column prop="ApplyClass" label="抢修类型"> </el-table-column>
      <el-table-column prop="name" label="申请人"> </el-table-column>
      <el-table-column prop="F_CreatorTime" label="申请日期" width="200">
      </el-table-column>
      <el-table-column prop="ApplyInfo" label="内容" width="200">
      </el-table-column>
      <el-table-column label="计划实施时间" width="160">
        <template slot-scope="scope">
          <span
            ><span>{{ scope.row.PlanBeginDate }}</span> <br /><span>{{
              scope.row.PlanEndDate
            }}</span></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="ProjectName" label="所属项目"> </el-table-column>
      <el-table-column prop="Contact" label="联系方式"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column prop="state" label="状态"> </el-table-column>
    </el-table>
    <div class="section-container" style="padding:1rem;" :class="{'dark':skinType}">
      <el-pagination
        v-if="pageInfo.total"
        :class="{'text-white':skinType}"
        style="text-align: right"
        background
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { getWorkList } from '@/api/maintain/maintain';
import { exportExcel } from '@/utils/utils';

export default {
  name: 'my-repairs',
  components: {
    SectionTitle,
  },
  data() {
    return {
      applyClass: '抢修',
      applyClassList: ['全部', '试验', '抢修'],
      pageInfo: {
        index: 1,
        size: 10,
        total: 1,
      },
      pageIndex: 1,
      tableData: [],
      selectPeriod: [],
    };
  },
  created() {
    this.requestApplyList();
  },
  watch: {
    pageIndex() {
      this.requestApplyList();
    },
    // 申请时间
    selectPeriod() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestApplyList();
    },
    // 申请类型
    applyClass() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestApplyList();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    onSubmit() {
      this.requestApplyList();
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
    pageChangeListener(no) {
      this.pageIndex = no;
    },
    requestApplyList() {
      var PlanBeginDate;
      var PlanEndDate;
      if(this.selectPeriod){
        if(this.selectPeriod.length!=0){
          PlanBeginDate=this.selectPeriod[0];
          PlanEndDate=this.selectPeriod[1];
        }
      }
      getWorkList({
        ApplyClass: this.applyClass,
        PlanBeginDate,
        PlanEndDate,
        page: this.pageIndex,
        rows: this.pageInfo.size,
      }).then((res) => {
        console.log(res);
        this.tableData = res.list || res;
        this.pageInfo.total = res.total || 0;
      });
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row';
      }
      if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    rowClickListener(row) {
      console.log(row);
    },
  },
};
</script>

<style scoped>

</style>
